<div class="row main-content">
  <div class="w15">
      <div class="sidebar">
          <ul>
            <li *ngIf="checkOVRInAgencyCode==='false'"  routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
            <li *ngIf="checkOVRInAgencyCode==='false'"  (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive=='false' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
            <li *ngIf="checkOVRInAgencyCode==='false'" class="active" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
            <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
            <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
            <li (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
            <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
            <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
            <li (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
          </ul>
      </div>
  </div>
  <div class="w85">
    <div *ngIf="showChangePolicy">
      <div class="whitebox p-3 posFixed">
          <label class="bold fs-18 m-0 cp" (click)="backToPolicySearch()">Policy Search</label>
          <label class="bold fs-20 m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
        <label class="bold fs-18 m-0 cp" (click)="backToPolicyDetails()">{{policyNumber}}</label>
        <label class="bold fs-20 txt-red m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
        <label class="bold fs-18 txt-red m-0 cp">Change Policy</label>
        <label class="bold fs-20 txt-red m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
        <label *ngIf="showChangePolicyStepOne" class="bold fs-18 txt-red m-0 cp">Step 1 : Plan and Trip Details</label>
        <label *ngIf="showChangePolicyStepTwo" class="bold fs-18 txt-red m-0 cp">Step 2 : Enter Information About Each Insured</label>
        <!-- <label *ngIf="showChangePolicyStepTwoB" class="bold fs-18 txt-red m-0 cp">Step 2b : Plan Option</label> -->
        <label *ngIf="showChangePolicyStepThree" class="bold fs-18 txt-red m-0 cp">Step 3 : Purchaser Information</label>
        <label *ngIf="showChangePolicyStepThreeAdminFee" class="bold fs-18 txt-red m-0 cp">&nbsp;&nbsp;<span class="bold txt-black fs-18">ADMINISTRATION FEE</span></label>
        <!-- <label *ngIf="showChangePolicyStepThreeAdminFee" class="bold fs-18 txt-red m-0 cp">Step 3 : Optional Trip Info&nbsp;>&nbsp;<span class="bold txt-black fs-18">ADMINISTRATION FEE</span></label> -->
        <label *ngIf="showChangePolicyStepFour" class="bold fs-18 txt-red m-0 cp">Step 4 : Payment</label>
        <label *ngIf="showChangePolicyStepFive" class="bold fs-18 txt-red m-0 cp">Step 5 : Final Preview and confirmation</label>
      </div>
      <div class="clear40"></div>
      <div class="clear20"></div>
      
      <div *ngIf="showChangePolicyStepOne" class="p-3">
          
          <div class="h100" >
          <div class="clear10"></div>
          <div class="" >
              <div class="conclass">
                  <div class="row">
                      <div class="col-lg-3 mycontent-right ">
                          <label for="" class="bold fs-18">TRIP INFORMATION</label>
                          <div class="clear10"></div>
                          <label class="regular lbl1 fs-16 tooltip1">Effective Date<span class="red5">*</span>
                              <img src="./assets/images/iIconblue.svg">
                              <div class="tooltiptext1 regular fs-14">
                              <span class="whitespacenormal italic tooltiptext2">Means the date on which your coverage commences as set out in Section 5 - EFFECTIVE AND EXPIRY DATES OF INSURANCE.</span>
                              </div>
                          </label>
                          <!-- <input readonly class="form-control forminput Tab"  placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [min]="minDate" [(ngModel)]="startDate" (ngModelChange)="callStartDateFunction($event)" >
                          <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time> -->
                          <div class="change-policy-datepicker">
                            <mat-form-field appearance="fill">
                              <input matInput [matDatepicker]="datepicker1" placeholder="ddmmmyyyy" [(ngModel)]="startDate" [min]="minDate" [max]="maxDatestart" (dateChange)="callStartDateFunction($event)">
                              <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
                              <mat-datepicker #datepicker1></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <p class="dateSubtxt1 regular red" *ngIf="startDateFlag" >Effective date is required</p>
                          <p class="dateSubtxt1 regular red" *ngIf="startDateFlagValid">‘Effective Date’ is not valid.</p>
                          <!-- <p class="italic fs-14">This is the date you leave on your covered trip</p> -->
                          <div class="clear20"></div>
                          <label class="regular fs-16 lbl1">Number of Travel Days</label>
                          <!-- <input class="form-control forminput Tab" type="number" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="calculatedDays" (ngModelChange)="callCalculatedDaysFunction()"> -->
                          <input class="form-control forminput Tab" placeholder="Number of Days" type="tel" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"   [(ngModel)]="calculatedDays" (ngModelChange)="callCalculatedDaysFunction()"  >
                          <!-- <p class="regular fs-16 red" *ngIf="errorNegative" >Number of travel days cannot be negative.</p> -->
                          <p class="regular fs-16 red" *ngIf="errorFlagNoDays">An ‘Effective Date’ is required before adding the ‘Number of Travel Days’.</p>
                          <p class="regular fs-16 red" *ngIf="errorNegative">Number of travel days cannot be negative.</p>
                          <p class="regular fs-16 red" *ngIf="exceedNoOfDays">The ‘Number of Travel Days’ exceeds the allowed number of days allowed for this plan.</p>
                          <p class="regular fs-16 red" *ngIf="exceedNoOfDays1">The ‘Number of Travel Days’ is less than the minimum number of days (14) allowed for this plan.</p>
                          <div class="clear20"></div>
                          <label class="regular fs-16 tooltip1 lbl1">Expiry Date<span class="red5">*</span>
                              <img src="./assets/images/iIconblue.svg">
                              <div class="tooltiptext1 regular fs-14">
                              <span class="whitespacenormal italic tooltiptext2">Means the date your coverage ends as set out in Section 5 - EFFECTIVE AND EXPIRY DATES OF INSURANCE.</span>
                              </div>
                          </label>
                          <!-- <input readonly class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [min]="minDate" [(ngModel)]="expiryDate" (ngModelChange)="callExpiryDateFunction($event)">
                          <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time> -->
                          <div class="change-policy-datepicker">
                            <mat-form-field appearance="fill">
                              <input matInput [matDatepicker]="datepicker2" placeholder="ddmmmyyyy" [(ngModel)]="expiryDate" [min]="minDate" (dateChange)="callExpiryDateFunction($event)">
                              <mat-datepicker-toggle matSuffix [for]="datepicker2"></mat-datepicker-toggle>
                              <mat-datepicker #datepicker2></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <p class="dateSubtxt1 red regular" *ngIf="expiryDateFlag">Expiry date is required</p>
                          <p class="dateSubtxt1 red regular" *ngIf="expiryDateFlagValid">Expiry date is not valid.</p>
                          <!-- <p class="italic fs-14">This is the date you return from your covered trip</p> -->
                          
                          <!-- <div class="clear20"></div>
                          <label class="regular fs-16">Resident of<span class="red5">*</span></label>
                          <ng-select placeholder="Select">
                              <ng-option>Pune</ng-option>
                              <ng-option>Mumbai</ng-option>
                              <ng-option>Nashik</ng-option>
                          </ng-select> -->
                      </div>
                      <div class="col-lg-8 padIn-12  ">
                          <label for="" class="bold fs-18">INSURED INFORMATION</label>
                          <div class="clear"></div>
                          <label class="lbl1 regular fs-16">Number of Insureds <span class="red5">*</span></label>
                          <div>
                              <button type="button" class="decBTN" (click)="minusNumberOfInsured()"><i
                                      class="fa fa-minus"></i></button>
                              <input type="text" class="incdecTxt" [(ngModel)]="insuredCount">
                              <button type="button" class="incBTN" (click)="incNumberOfInsured()"><i
                                      class="fa fa-plus"></i></button>
                          </div>
                          <div class="clear30"></div>
                          <div class="horizontal"></div>
                          <div class="clear30"></div>
                          <div  *ngFor="let item of travellerInfo; let i=index">
                              <label for="" class="bold fs-18">INSURED #{{i+1}}
                                  <u class="red5 pl-3 cp" *ngIf="showRemove" (click)="minusNumberOfInsuredShort(i)" >Remove</u>
                              </label>
                              <ng-container>
                                  <div>
                                      <div class="row">
                                          <div class="col-lg-4 padIn-12 padInR-12">
                                              <label class="regular fs-16 tooltip1 lbl1">Date of Birth (DOB)<span class="red5">*</span>
                                                  <img src="./assets/images/iIconblue.svg">
                                                   <div class="tooltiptext1 regular fs-14">
                                                      <span class="whitespacenormal italic tooltiptext2">DOB is the insured’s date of birth.</span>
                                                  </div>   
                                              </label>
                                              <!-- <input readonly class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [max]="minDate1"  [(ngModel)]="item.dateOfBirth" (ngModelChange)="callDateOfBirth($event)" >
                                              <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time> -->
                                              <div class="change-policy-datepicker">
                                                <mat-form-field appearance="fill">
                                                  <input matInput [matDatepicker]="datepicker3" placeholder="ddmmmyyyy" [(ngModel)]="item.dateOfBirth" [max]="minDate1" (dateChange)="callDateOfBirth($event)">
                                                  <mat-datepicker-toggle matSuffix [for]="datepicker3"></mat-datepicker-toggle>
                                                  <mat-datepicker #datepicker3></mat-datepicker>
                                                </mat-form-field>
                                              </div>
                                              <p class="dateSubtxt1 red" *ngIf="item.dobFlag">DOB is is not valid.</p>
                                              <p class="dateSubtxt1 red" *ngIf="item.ageErrorCross" >The ‘Date of Birth’ entered falls outside the age eligible for coverage under this plan.</p>
                                          </div>
                                          <div class="col-lg-2 padIn-12 padInR-12">
                                              <label class="regular fs-16 tooltip1 lbl1">Age<span class="red5">*</span>
                                                  <img src="./assets/images/iIconblue.svg">
                                                  <div class="tooltiptext1 regular fs-14">
                                                  <span class="whitespacenormal italic tooltiptext2">means your age on the date you apply for coverage.</span>
                                                  </div>
                                              </label>
                                              <input type="text" value="25 Y" class="greenTxt" readonly [(ngModel)]="item.age">
                                          </div>
                                          <div class="col-lg-4 padIn-12 padInR-12">
                                              <label class="regular fs-16 lbl1 tripCost">Arrival in Canada<span class="red5">*</span></label>
                                              <!-- <input readonly class="form-control forminput Tab" placeholder="MM-DD-YYYY" [max]="minDateArrival" [(ngModel)]="item.arrivalDateOfCanada" (ngModelChange)="callArriveCanadaDate($event,i)" [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10">
                                              <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time> -->
                                              <div class="change-policy-datepicker">
                                                <mat-form-field appearance="fill">
                                                  <input matInput [matDatepicker]="datepicker4" placeholder="ddmmmyyyy" [(ngModel)]="item.arrivalDateOfCanada" [max]="minDateArrival" (dateChange)="callArriveCanadaDate($event,i)">
                                                  <mat-datepicker-toggle matSuffix [for]="datepicker4"></mat-datepicker-toggle>
                                                  <mat-datepicker #datepicker4></mat-datepicker>
                                                </mat-form-field>
                                              </div>
                                              <p class="dateSubtxt1 red" *ngIf="item.arrivalDateCanadaFlag">Arrival date is required</p>
                                              <p class="dateSubtxt1 red" *ngIf="item.ArrivalDateFlagValid">Arrival date is not valid</p>
                                          </div>
                                          <div class="col-lg-2 padIn-12 padInR-12">
                                              <label class="regular fs-16 lbl1">Wait Period</label>
                                              <input class="waitperiodBOX"   [(ngModel)]="item.waitPeroid" readonly>
                                              <!-- <div class="waitperiodBOX fs-12" readonly [(ngModel)]="item.waitPeroid"></div> -->
                                          </div>
                                          <!-- <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                              <label class="regular fs-16">Wait Period</label>
                                              <div class="waitperiodBOX col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">48 hours for a Sickness, 24 hours for an injury</div>
                                          </div> -->
                                      </div>
                                  </div>
                              </ng-container>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="clear20"></div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
          <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Cancel</button>
          <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Back</button>
          <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepOneNext()">Continue Next</button> -->
          <button type="submit" class="ContinueandNextbtn ml-1 bold" *ngIf="errorFlagNoDays==true || errorNegative==true || exceedNoOfDays==true || exceedNoOfDays1==true || ageErrorCross==true || expiryDateFlagValid==true || startDateFlagValid==true || ArrivalDateFlagValid==true" (click)="onClickToShowPlanInfo1()">Next</button>
          <button type="submit" class="ContinueandNextbtn ml-1 bold"  *ngIf="errorFlagNoDays==false && errorNegative==false && exceedNoOfDays==false && exceedNoOfDays1==false && ageErrorCross==false && expiryDateFlagValid==false && startDateFlagValid==false && ArrivalDateFlagValid==false"(click)="onClickToShowPlanInfo()">Next</button>
        </div>
      </div>
    </div>
  
    <!-- Popup modal  -->
    <div id="showarrivalDateInCanadaPopup" class="modal" [style.display]="showarrivalDateInCanadaPopup ? 'block' : 'none'">
      <div class="modal-content">
          <div class="modal-header">
              <span class="fs-16 text46 semi-bold">Is the plan being purchased in continuation of an existing International Student Policy purchased from Travelance, with no gap in coverage?</span>
          </div>
          <div class="modal-body">
              <div class="row">
                  <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                      <label class="regular fs-14 txt-black">Select</label>
                      <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                          <ng-select [(ngModel)]="selectedQuestionAns1" (change)="onClickQuestion1(selectedQuestionAns1)">
                              <ng-option disabled selected value=undefined>Select</ng-option>
                              <ng-option value="Yes">Yes</ng-option>
                              <ng-option value="No">No</ng-option>
                          </ng-select>
                      </div>
                  </div>
              </div>
              <div class="clear20"></div>
              <div class="row" *ngIf="innerPop">
                  <label class="fs-16 text46 semi-bold">Was the current Visitors to Canada policy purchased from Travelance?</label>
                  <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                      <label class="regular fs-14 txt-black">Select</label>
                      <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                          <ng-select [(ngModel)]="selectedQuestionAns2" (change)="onClickQuestion2(selectedQuestionAns2)">
                              <ng-option disabled selected value=undefined>Select</ng-option>
                              <ng-option value="Yes">Yes</ng-option>
                              <ng-option value="No">No</ng-option>
                          </ng-select>
                      </div>
                  </div>
              </div>
              <div class="clear20"></div>
              <div class="text-right mr-5">
                  <button type="button" class="fs-14 bold okbtngreen" *ngIf="showOkButton" (click)="modalCloseQuestion()">OK</button>
              </div>
          </div>
      </div>
  </div>

      <!--  
      <div *ngIf="showChangePolicyStepOne" class="p-3">
        <label class="bold fs-16 txt-black">TRIP INFORMATION</label>
        <div class="clear10"></div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Application Date</label>
            <input class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1">
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Start Date<span class="txt-red">*</span></label>
            <input class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2">
            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16 ">Number of Days<span class="txt-red">*</span></label>
            <input type="text" class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Expiry Date<span class="txt-red">*</span></label>
            <input class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2">
            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Plan</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Destination</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
        </div>
         
        <div class="clear20"></div>
        <div class="border-bottom"></div>
        <div class="clear20"></div>
        <label class="bold fs-16 txt-black">OPTIONAL TRIP INFO</label>
        <div class="clear10"></div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Departure City</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Airline<span class="cp link">(Details)</span></label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Cruise Line<span class="cp link">(Details)</span></label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <label class="regular fs-16">Tour Operator<span class="cp link">(Details)</span></label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
        </div> 
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
            <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepOneBack()">Go Back</button>
            <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepOneNext()">Continue Next</button>
          </div>
        </div>
      </div>
  -->

  <!-- commented below part as we have to design a new page -->
      <!-- <div *ngIf="showChangePolicyStepTwo" class="p-3">
        <label class="bold fs-16 txt-black">TRIP INFO</label>
        <div class="clear10"></div>
        <div style="display: flex;">
          <div>
            <button type="button" class="decBTN" (click)="minusNumberOfInsured()"><i class="fa fa-minus"></i></button>
            <input type="text" class="incdecTxt" [value]="numberOFInsured">
            <button type="button" class="incBTN" (click)="incNumberOfInsured()"><i class="fa fa-plus"></i></button>
          </div>
          <div class="incdecAndcheckbox">
            <label class="container">
            <input type="checkbox" class="form-check-input">
            <span class="checkmark"></span>
            </label>
            <span class="fs-14 bold">Family Rate</span>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">First Name</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name">
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">Last Name</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name">
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Date of Birth<span class="txt-red">*</span></label>
            <input class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5">
            <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 col-xl-12 col-lg-12">Your Age</label>
            <input type="text" value="25 Y" class="greenTxt" readonly>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Trip Cost</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">Amount after</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Language<span class="txt-red">*</span></label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Arrival Date in Canada<span class="txt-red">*</span></label>
            <input class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt6" [owlDateTime]="dt6">
            <owl-date-time [pickerType]="'calendar'" #dt6></owl-date-time>
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Wait Period</label>
            <div class="waitperiodBOX col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">48 hours for a Sickness, 24 hours for an injury</div>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="border-bottom"></div>
        <div class="clear20"></div>
        <label class="bold fs-16 txt-black">PURCHASER INFORMATION</label>
        <div class="clear10"></div>
        <label class="regular fs-14 txt-black">At the time of purchase, is the purchaser residing in Canada?</label>
        <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 col-12">
          <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                <div>
                    <input type="radio">
                    <label class="regular fs-14 txt-black">&nbsp;Yes</label>
                </div>                    
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                <div>
                    <input type="radio">
                    <label class="regular fs-14 txt-black">&nbsp;No</label>
                </div>
            </div>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">First Name</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name">
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">Last Name</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name">
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
            <label class="regular fs-14 txt-black">Address Line 1</label>
              <div>
                <textarea rows="3" class="textarea regular col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
              </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
            <label class="regular fs-14 txt-black">Address Line 2</label>
            <div>
              <textarea rows="3" class="textarea regular col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
            </div>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">City</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="City">
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">State</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>            
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">Postal Code</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Postal Code">
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Phone 1 (Optional)</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Phone 1">
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">Phone 2 (Optional)</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Phone 2">
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Email Address</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Email Address">
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16 ">Confirm Email Address</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Confirm Email Address">
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
            <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepTwoBack()">Go Back</button>
            <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepTwoNext()">Continue Next</button>
          </div>
        </div>
      </div> -->
      <!-- <div *ngIf="showChangePolicyStepTwoB" class="p-3">
        <label class="bold fs-16 txt-black">PLAN DETAILS</label>
        <div class="clear10"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Insured</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Insured">
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Options</label>
            <div>
              <label class="container">
              <input type="checkbox" class="form-check-input">
              <span class="checkmark"></span>
              </label>
              <span class="fs-14 bold ml30">Deductible Option</span>
            </div>            
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Choice</label>
            <ng-select placeholder="Select" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
              <ng-option>Dummy</ng-option>
              <ng-option>Dummy</ng-option>
            </ng-select>            
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
            <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepTwoBBack()">Go Back</button>
            <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepTwoBNext()">Continue Next</button>
          </div>
        </div>
      </div> -->

      <!-- <div *ngIf="showChangePolicyStepThree" class="p-3">
        <label class="bold fs-16 txt-black">OPTIONAL TRIP INFO</label>
        <div class="clear10"></div>
        <div class="row">
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="regular fs-16">Beneficiary (Estate if left blank)</label>
            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Beneficiary">
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
            <label class="regular fs-14 txt-black">Comments</label>
              <div>
                <textarea rows="3" class="textarea regular col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
              </div>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
            <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepThreeBack()">Go Back</button>
            <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepThreeNext()">Continue Next</button>
          </div>
        </div>
      </div> -->



      <!-- Re-Designed Page -->
      <div *ngIf="showChangePolicyStepTwo">
          <div class="conclass">
              <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                  <div class="whitebox br-6 p-2 mr-2">
                      <div class="border-bottom p-2">
                          <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                      </div>
                      <div class="p-2">
                          <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                          <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
                       
                          <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                          <p class="purple bold fs-16">{{daysToshow}}</p>
                          <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                          <label class="purple bold fs-16">{{purchaseProvince}}</label><br>
                          <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insureds:</label><br>
                          <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                          <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                              <img src="./assets/images/iIconblue.svg">
                          <div class="tooltiptext1 regular fs-14">
                              <span class="whitespacenormal  tooltiptext2">DOB is the insured's date of birth.</span>
                          </div>
                          </label>
                          <div class="purple bold fs-16 " *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                         
                          
                          
                          <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                          <p *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - (Age: {{item.age}})</p>
                          <label class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                          <div *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - ({{item.waitPeroid}})</div>
                          <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                          <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                          <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                          <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                          <!-- <div class="horizontal mt-1"></div>
                          <ul id="popupbullets" class="ulbulletclass">
                              <li class="desclist">
                                  Quoted rate is valid today only.
                              </li>
                              <li class="desclist ">Click on ‘View Details’ under a plan name for detailed information, including the policy wording.</li>
                              <li class="desclist ">If you have a pre-existing medical condition, some conditions to the terms of your coverage may apply. Please read the policy for details.</li>
                          </ul> -->
                      </div>
                  </div>
              </div>
                  <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8">
                      <div class="border-bottom ml-2 mr-2"></div>
                      <div class="p-2">
                          <label class="bold fs-16">ENTER INFORMATION ABOUT EACH INSURED</label>
                      </div>
                      <div *ngFor="let item of insuredPersonArray;let i=index">
                      <div class="p-2">
                          <label class="bold fs-16" >INSURED #{{i+1}} </label>
                      </div>
                      
                          <div class="row ml-3 mb-3">
                              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                  <label class="regular fs-14 txt-black">First Name<span class="redstar">*</span></label>
                                  <div>
                                      <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name" onkeydown="return /[a-z \s \-\/]/i.test(event.key)" [(ngModel)]="item.firstName" (input)="removeFirstNameError(i)" maxlength="64">
                                      <p class="dateSubtxt1 redstar" *ngIf="item.firstNameFlag" >First name is required</p>
      
                                  </div>
                              </div>
                              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                  <label class="regular fs-14 txt-black">Last Name<span class="redstar">*</span></label>
                                  <div>
                                      <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name" onkeydown="return /[a-z \s \-\/]/i.test(event.key)" [(ngModel)]="item.lastName" (input)="removeLastNameError(i)" maxlength="64">
                                      <p class="dateSubtxt1 redstar" *ngIf="item.lastNameFlag" >Last name is required</p>
      
                                  </div>
                              </div>
                          </div>
                          <div class="row ml-3 mb-3" *ngIf="i==0">
                              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                  <label class="regular fs-14 txt-black">Institute’s name <span class="redstar">*</span></label>
                                  <div>
                                      <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Institute Name"  [(ngModel)]="item.insitute" (input)="removeInstituteNameError(i)">
                                      <p class="dateSubtxt1 redstar" *ngIf="item.InstituteFlag">Institute’s name  is required</p>
      
                                  </div>
                              </div>
                              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" *ngIf="i==0 && !NonResidentSelected" >
                                  <label class="regular fs-14 txt-black">Home Country<span class="redstar">*</span></label>
                                  <div>
                                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="item.homeCountry" (input)="removeCountryNameError(i)" >
                                          <ng-option *ngFor="let item of countryListing" [value]="item">{{item}}</ng-option>
                                        
                                      </ng-select>
                                      <p class="dateSubtxt1 redstar" *ngIf="item.CountryFlag" >Country is required</p>
      
                                  </div>
                              </div>
                              <!-- <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                  <label class="regular fs-14 txt-black">Home Country <span class="redstar">*</span></label>
                                  <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Home Country" [(ngModel)]="item.firstName" (input)="removeFirstNameError()">
                                   <div>
                                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                                          <ng-option>Dummy</ng-option>
                                          <ng-option>Dummy</ng-option>
                                          <ng-option>Dummy</ng-option>
                                      </ng-select>
                                  </div> 
                              </div> -->
                          </div>
                          <div class="clear10"></div>
                      </div>
                  <div class="border-bottom"></div>
                  <div class="clear10"></div>
                          <div>
                              <label class="ml-3">Please enter the primary address where the insured will be staying while in Canada</label>
                          </div>
                  <div class="row ml-3 mb-3">
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Address Line 1 </label>
                            <!-- <input  class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="primaryAddress1"> -->
                            <input  class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="primaryAddress1" (input)="callAddressApiCall()">
                            <!-- <p class="dateSubtxt1 redstar" *ngIf="primaryAddress1Flag">'Address' is required.</p>  -->
                            <div class="searchResultBox" *ngIf="showAddressResults1">
                              <h6 class="close1 text-right mt-1 mr-1" (click)=" this.showAddressResults1 = !this.showAddressResults1;">&times;</h6>
                              <div class="borderbottom">
                                  </div>
                                  <div class="row borderbottom p-1" *ngFor="let item of getPrimaryAddress">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <label class="fs-14 regular m-0 link cp" (click)="onClickSearchResultprimary(item)">{{item.place_name}}</label><br>
                                    </div>
                                  </div>
                              </div>
                          
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Address Line 2</label>
                          <div>
                            <input class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="primaryAddress2">                              
                          </div>
                      </div>
                  </div>
                  <div class="row ml-3 mb-3">
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">City</label>
                          <div>
                              <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="City" [(ngModel)]="primaryCity" (input)="onCityClick()">
                              <!-- <p class="dateSubtxt1 redstar" *ngIf="primaryCityFlag" >City is required</p> -->
                          </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Province</label>
                          <div>
                              <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="primaryProvince" (click)="onProvinceClick()" >
                                  <!-- <ng-option *ngFor="let item of countryListing" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                                  <ng-option value="Non-Resident of Canada">Non-Resident of Canada</ng-option>             -->
                                  <ng-option selected disabled value=undefined>Select</ng-option>
                                  <ng-option *ngFor="let item of provincesArray" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                                  <ng-option value="Non-Resident of Canada">Non-Resident of Canada
                                  </ng-option>
                              </ng-select>
                              <!-- <p class="dateSubtxt1 redstar" *ngIf="primaryProvinceFlag">Province is required</p> -->

                          </div>
                      </div>
                  </div>
                  <div class="row ml-3 mb-3 ">
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Postal Code</label>
                          <div>
                              <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="primaryPostalCode" (input)="onPostalCodeClick()" maxlength="7">
                              <!-- <p class="dateSubtxt1 redstar" *ngIf="primaryPostalCodeFlag" >Postal code is required</p> -->
                          </div>
                      </div>
                  </div>
                  <div class="row ml-3 mb-3" *ngIf="!NonResidentSelected">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                          <div>
                              <input [disabled]="showcheckbox==false"  type="checkbox" [checked]="purchaserAddressSame"  (change)="onClickAddressSameCheckbox($event)" >
                              <span class="ml10">Check this box if this address is the same address as the person purchasing this policy.</span>
                          </div>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="clear20"></div>
              <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                    <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Cancel</button>
                      <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepTwoBack()">Back</button>
                      <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepTwoNext()">Continue Next</button> -->
                      <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickContactInfoNext()">Next</button>  
                  </div>
              </div>
              
          </div>     
  </div>
      <!-- End of Step-2 Page -->

  <!-- New Page Purchaser Information Start -->
   
  <div *ngIf="showChangePolicyStepThree">
      <div class="conclass">
          <!-- <div class="row" *ngFor="let item of insuredPersonArray;let i=index"> -->
            <div class="row">
              <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                <div class="whitebox br-6 p-2 mr-2">
                    <div class="border-bottom p-2">
                        <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                    </div>
                    <div class="p-2">
                        <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                        <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
                     
                        <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                        <p class="purple bold fs-16">{{daysToshow}}</p>
                        <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                        <label class="purple bold fs-16">{{purchaseProvince}}</label><br>
                        <div  *ngIf="NonResidentSelected">
                          <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser’s Country of Residence::</label><br>
                          <label class="purple bold fs-16">{{purchaserCountryName}}</label><br>
                        </div>
                        <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insureds:</label><br>
                        <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                        <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                            <img src="./assets/images/iIconblue.svg">
                        <div class="tooltiptext1 regular fs-14">
                            <span class="whitespacenormal  tooltiptext2">DOB is the insured's date of birth.</span>
                        </div>
                        </label>
                        <div class="purple bold fs-16 " *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                       
                        
                        
                        <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                        <p *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - (Age: {{item.age}})</p>
                        <label class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                        <div *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - ({{item.waitPeroid}})</div>
                        <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                        <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                        <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                        <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                        <!-- <div class="horizontal mt-1"></div>
                        <ul id="popupbullets" class="ulbulletclass">
                            <li class="desclist">
                                Quoted rate is valid today only.
                            </li>
                            <li class="desclist ">Click on ‘View Details’ under a plan name for detailed information, including the policy wording.</li>
                            <li class="desclist ">If you have a pre-existing medical condition, some conditions to the terms of your coverage may apply. Please read the policy for details.</li>
                        </ul> -->
                    </div>
                </div>
            </div>
              <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8">
                  <div class="border-bottom ml-2 mr-2"></div>
                  <div class="p-2">
                      <label class="bold fs-16">PURCHASER INFORMATION</label>
                  </div>
                  <div >
                  <!-- <div class="p-2">
                      <label class="bold fs-16" >TRAVELER #{{i+1}} - <span style="color:#0066cc" *ngFor="let item of travellerInformation">Age: {{item.age}}</span></label>
                  </div> -->
                  
                      <div class="row ml-3 mb-3">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">First Name<span class="redstar">*</span></label>
                          <div>
                              <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name" onkeydown="return /[a-z \s \-\/]/i.test(event.key)" [(ngModel)]="purchaserFirstName" maxlength="20">
                              <p class="dateSubtxt1 redstar" *ngIf="purchaserFirstNameFlag" >First name is required</p>

                          </div>
                      </div>
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                              <label class="regular fs-14 txt-black">Last Name<span class="redstar">*</span></label>
                              <div>
                                  <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name" onkeydown="return /[a-z \s \-\/]/i.test(event.key)" [(ngModel)]="purchaserLastName" maxlength="20">
                                  <p class="dateSubtxt1 redstar" *ngIf="purchaserLastNameFlag" >Last name is required</p>
  
                              </div>
                          </div>
                        
                      </div>
                      <div class="row ml-3 mb-3" *ngIf="!NonResidentSelected">
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                              <label class="regular fs-14 txt-black">Address  1 <span class="redstar">*</span></label>
                              <div>
                                <!-- <input type="text" class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchaserAddress1"> -->
                                <input type="text" class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchaserAddress1" (input)="callAddressApiCall1()">
                                  <div class="searchResultBox" *ngIf="showAddressResults1">
                                    <h6 class="close1 text-right mt-1 mr-1" (click)=" this.showAddressResults1 = !this.showAddressResults1;">&times;</h6>
                                      <div class="borderbottom">
                                      </div>
                                      <div class="row borderbottom p-1" *ngFor="let item of getAddress1">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                          <label class="fs-14 regular m-0 link cp" (click)="onClickSearchResult1(item)">{{item.place_name}}</label><br>
                                        </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" *ngIf="!NonResidentSelected">
                              <label class="regular fs-14 txt-black">Address  2</label>
                              <div>
                                <input type="text" class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchaserAddress2">
                                  
                              </div>
                          </div>
                      </div>
                      <div class="row ml-3 mb-3">
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                              <label class="regular fs-14 txt-black">Language<span class="red5">*</span></label>
                              <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                                  <ng-select [(ngModel)]="selectedQuestionlanguages1" placeholder="Select" (click)="validateLanguage(selectedQuestionlanguages1)">                            
                                      <ng-option selected disabled value=undefined>Select</ng-option>
                                      <ng-option *ngFor="let item of languagesArray" [value]="item">{{item}}</ng-option>
          
                                  </ng-select>
                              </div>
                           </div>
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" *ngIf="!NonResidentSelected">
                              <label class="regular fs-14 txt-black">Province<span class="redstar">*</span></label>
                              <div>
                                  <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="purchaseProvince" (click)="onProvinceClick()" >
                                      <!-- <ng-option *ngFor="let item of countryListing" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                                      <ng-option value="Non-Resident of Canada">Non-Resident of Canada</ng-option>             -->
                                      <ng-option selected disabled value=undefined>Select</ng-option>
                                      <ng-option *ngFor="let item of provincesArray" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                                      <ng-option value="Non-Resident of Canada">Non-Resident of Canada
                                      </ng-option>
                                  </ng-select>
                                  <p class="dateSubtxt1 redstar" *ngIf="purchaseProvinceFlag">Province is required</p>
      
                              </div>
                          </div>
                      </div>
                      <div class="clear20"></div>
                      <div class="row ml-3 mb-3 " *ngIf="!NonResidentSelected">
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" >
                              <label class="regular fs-14 txt-black">City<span class="redstar">*</span></label>
                              <div>
                                  <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="City" [(ngModel)]="purchaseCity" (input)="onCityClick()">
                                  <p class="dateSubtxt1 redstar" *ngIf="purchaseCityFlag" >City is required</p>
                              </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" >
                              <label class="regular fs-14 txt-black">Postal Code<span class="redstar">*</span></label>
                              <div>
                                  <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchasePostalCode" (input)="onPostalCodeClick()" maxlength="7">
                                  <p class="dateSubtxt1 redstar" *ngIf="purchasePostalCodeFlag" >Postal code is required</p>
                              </div>
                          </div>
                      </div>
                      <div class="clear20"></div>
                      <div class="row ml-3 mb-3">
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                              <label class="regular fs-14 txt-black tooltip1">Phone 1<span class="redstar" *ngIf="!NonResidentSelected">*</span>
                                <img src="./assets/images/iIconblue.svg">
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">International phone numbers can be added in the 'Comments' section, if required.</span>
                                </div>
                              </label>
                              <div>
                                  <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type Here" [(ngModel)]="purchasePhone1" maxlength="15" (input)="onPhoneClick1();checkPatternWork()">
                                  <p class="dateSubtxt1 redstar" *ngIf="purchasePhone1Flag">Phone1 is required</p>
                                  <p class="dateSubtxt1 redstar" *ngIf="notValidPhoneNo">Phone Number is not valid.</p>
                              </div>
                          </div>
                          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                              <label class="regular fs-14 txt-black">Phone 2</label>
                              <div>
                                  <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type Here" [(ngModel)]="purchasePhone2">
                              </div>
                          </div>
                      </div>
                      <div class="clear20"></div>
                  <div class="row ml-3 mb-3">
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Email Address<span class="redstar">*</span></label>
                          <div>
                              <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Email Address" [(ngModel)]="purchaseEmail"  (input)="onEmailClick();emailCheck();checkConfirmEmail()">
                              <p class="dateSubtxt1 redstar" *ngIf="purchaseEmailFlag">Email is required</p>
                              <p class="dateSubtxt1 redstar" *ngIf="emailNotValid">Email is not valid.</p>
                          </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Confirm Email Address<span class="redstar">*</span></label>
                          <div>
                              <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Confirm Email Address"  [(ngModel)]="purchaseEmailConfirm" (input)="checkConfirmEmail();onConfirmEmailClick()">
                              <p class="dateSubtxt1 redstar"  *ngIf="purchaseConfirmEmailFlag">'Confirm Email Address' is required.</p>
                              <p class="dateSubtxt1 redstar" *ngIf="confirmEmailMatch">Email and confirm email not match.</p>
                          </div>
                      </div>
                  </div>
                  <div class="clear10"></div>
                  <div class="border-bottom"></div>
                  <div class="clear10"></div>
                  <label class="bold fs-18 ml-3">Optional Information</label>
                  <div class="clear10"></div>
                  <div class="row ml-3 mb-2">
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Comments</label>
                          <div>
                              <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="comment"></textarea>
                          </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                          <label class="regular fs-14 txt-black">Beneficiary</label>
                          <div>
                              <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="beneficiary"></textarea>
                          </div>
                      </div>
                  </div>
                  <!-- <div class="clear20"></div>
                  <div class="row ml-3 mb-3">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                          <label class="regular fs-14 txt-black">Agent Note</label>
                          <div>
                              <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="agentNote"></textarea>
                          </div>
                      </div>
                  </div> -->
                  </div>
              </div>
          </div>
          <div class="clear20"></div>
          <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Cancel</button>
                  <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepThreeBack()">Back</button>
                  <!-- <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepTwoBack()">Go Back</button> -->
                  <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepTwoNext()">Continue Next</button> -->
                  <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickPurchaseInfoNext() ">Next</button>  
                  <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepThreeNext() ">Continue Next</button> -->
              </div>
          </div>
          
      </div>     
  </div>
 <!-- End of Step-3 Page -->


      <!-- <div *ngIf="showChangePolicyStepThreeAdminFee" class="p-3">
        <label class="bold fs-16 txt-black">ADMINISTRATION FEE</label>
        <div class="clear10"></div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
            <label class="regular fs-14 txt-black">Fee Amount<span class="italic">&nbsp;(Select a fee from the list, or enter a value in the text box)</span></label>
              <div class="row">
                <ng-select placeholder="Select" class="col-12 col-sm-3 col-md-3 col-lg-2 col-xl-2">
                  <ng-option>Dummy</ng-option>
                  <ng-option>Dummy</ng-option>
                </ng-select>
                <label class="col-lg-1 col-xl-1 regular fs-14 text-center">or</label>
                <ng-select placeholder="Select" class="col-12 col-sm-3 col-md-3 col-lg-2 col-xl-2">
                  <ng-option>Dummy</ng-option>
                  <ng-option>Dummy</ng-option>
                </ng-select>   
              </div>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
            <label class="regular fs-14 txt-black">Fee Reason</label>
              <div>
                <textarea rows="3" class="textarea regular col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
              </div>
          </div>
        </div>
        <div class="clear20"></div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
            <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepThreeAdminTreeBack()">Go Back</button>
            <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepThreeAdminTreeNext()">Continue Next</button>
          </div>
        </div>
      </div> -->
      <!-- Admission Fee Page Start -->
<div *ngIf="showChangePolicyStepThreeAdminFee">
  <div class="conclass">
      <div class="row">
        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
          <div class="whitebox br-6 p-2 mr-2">
              <div class="border-bottom p-2">
                  <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
              </div>
              <div class="p-2">
                  <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                  <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
               
                  <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                  <p class="purple bold fs-16">{{daysToshow}}</p>
                  <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                  <label class="purple bold fs-16">{{purchaseProvince}}</label><br>
                  <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insureds:</label><br>
                  <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                  <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                      <img src="./assets/images/iIconblue.svg">
                  <div class="tooltiptext1 regular fs-14">
                      <span class="whitespacenormal  tooltiptext2">DOB is the insured's date of birth.</span>
                  </div>
                  </label>
                  <div class="purple bold fs-16 " *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                 
                  
                  
                  <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                  <p *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - (Age: {{item.age}})</p>
                  <label class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                  <div *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - ({{item.waitPeroid}})</div>
                  <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                  <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                  <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                  <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                  <!-- <div class="horizontal mt-1"></div>
                  <ul id="popupbullets" class="ulbulletclass">
                      <li class="desclist">
                          Quoted rate is valid today only.
                      </li>
                      <li class="desclist ">Click on ‘View Details’ under a plan name for detailed information, including the policy wording.</li>
                      <li class="desclist ">If you have a pre-existing medical condition, some conditions to the terms of your coverage may apply. Please read the policy for details.</li>
                  </ul> -->
              </div>
          </div>
      </div>
          <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8">
              <div class="border-bottom ml-2 mr-2"></div>
              <div class="p-2">
                  <label class="bold fs-16">ADMINISTRATION FEE</label>
              </div>
                  <div class="clear10"></div>
                  <div class="horizontal"></div>
                  <div class="row ml-3 mb-2">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                      <label class="regular fs-14 txt-black ">Admin Fee Amount <span class="redstar">*</span></label>
                        <div class="row ">
                          <ng-select placeholder="Select"  class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12" [(ngModel)]="adminFee" (change)="onadminFeeClick()">
                            <ng-option value="0">$0</ng-option>
                            <!-- <ng-option value="10">$10</ng-option> -->
                            <ng-option value="25">$25</ng-option>
                            <ng-option value="50">$50</ng-option>
                            
                            <!-- <ng-option>Dummy</ng-option> -->
                          </ng-select>

                          <!-- <label class="col-lg-1 col-xl-1 regular fs-14 text-center">or</label>
                          <input type="text" placeholder="Type here" class=" form-control forminput1 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12" [(ngModel)]="adminFee" (input)="onadminFeeClick()"> -->
                        </div>
                        <p class="dateSubtxt1 redstar"  *ngIf="adminfeeerror">'Admin fee' is required.</p>
                        
                        
                    </div>
                  </div>
                  <div class="clear20"></div>
                  <div class="row  ml-3 mb-3">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                      <label class="regular fs-14 txt-black textcolor" >Fee Reason <span class="redstar">*</span></label>
                        <div>
                          <textarea rows="3" class="textarea regular  col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" placeholder="Type here" [(ngModel)]="adminFeeReason" (input)="onadminFeeReasonClick()"></textarea>
                        </div>
                        <p class="dateSubtxt1 redstar"  *ngIf="adminFeeReasonerror">'Admin fee reason' is required.</p>
                    </div>
                  </div>
                  <div class="clear20"></div>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                      <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Cancel</button>
                      <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepThreeAdminTreeBack()">Back</button>
                      <button type="submit" class="ContinueandNextbtn ml-1 bold" *ngIf="adminfeeerror==true || adminFeeReasonerror==true" >Next</button>
                      <button type="submit" class="ContinueandNextbtn ml-1 bold" *ngIf="adminfeeerror==false && adminFeeReasonerror==false" (click)="onClickChangePolicyStepThreeAdminTreeNext()">Next</button>
                    </div>
                  </div>
                
          </div>
      </div>
      
      <!-- <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
              <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepThreeBack()">Go Back</button>
            <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepTwoBack()">Go Back</button> -->
              <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepTwoNext()">Continue Next</button> 
                <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickContactInfoNext() ">Continue Next</button>   
              <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepThreeNext() ">Continue Next</button>
          </div>
      </div> -->
      
  </div>     
</div>
<!-- Admission Fee Page End -->

      <!-- <div *ngIf="showChangePolicyStepFour" class="p-3">
        <div class="payMentBox borderRed col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
          <div class="border-bottom p-2">
              <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="txt-red bold fs-16">Payments</span>
          </div>
          <div class="clear10"></div>
          <label class="regular fs-14 txt-black">Payment Schedule<span class="txt-red">*</span></label>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                  <div>
                      <input type="radio">
                         <label>Pay In Full : $17.64</label>
                  </div>                    
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                  <div>
                      <input type="radio">
                      <label>&nbsp;Monthly : $18.64</label>
                  </div>
              </div>
          </div>
          </div>
          <div class="clear10"></div>
          <label class="bold fs-14 txt-red">Payment: 1</label>
          <div class="row">
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                  <label class="regular fs-14 txt-black">Total Amount</label>
                  <div>
                      <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                  </div>
              </div>
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                  <label class="regular fs-14 txt-black">Payment Type</label>
                  <div>
                      <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                          <ng-option>Credit Card</ng-option>
                          <ng-option>Net Banking</ng-option>
                      </ng-select>
                  </div>
              </div>
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                <label class="regular fs-14 txt-black">Card Number</label>
                <div>
                    <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
                <label class="regular fs-14 txt-black">Expiry (mm/yy)</label>
                <div>
                    <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                </div>
            </div>
          </div>
          <div class="clear20"></div>
          <button type="button" class="fs-14 bold splitPaymentbtn">Split Payment</button>
      </div>
      <div class="clear10"></div>
      <label class="bold fs-16 txt-black">PLAN AND PAYMENT DETAILS</label>
      <div class="clear10"></div>
      <div class="whitebox1">
        <label class="bold fs-16 txt-red m-0">Payments</label>
        <div class="clear5"></div>
        <div class="border-bottom"></div>
        <div class="clear5"></div>
        <div class="row">
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Amount</label>
                <div class="bold fs-14 green">$403.02</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Premium</label>
                <div class="bold fs-14 purple">$373.75</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Tax</label>
                <div class="bold fs-14 purple">$11</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                <div class="bold fs-14 purple">$20</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Total Billing Fee</label>
                <div class="bold fs-14 purple">$75</div>
            </div>
        </div>
    </div>
      <div class="clear20"></div>
      <div class="whitebox1">
          <label class="bold fs-16 txt-red m-0">Plan:</label>
          <label class="bold fs-16 txt-red m-0">&nbsp;&nbsp;Visitors To Canada Premier Plan</label>
          <div class="clear5"></div>
          <div class="border-bottom"></div>
          <div class="clear5"></div>
          <div class="row">
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Total</label>
                  <div class="bold fs-14 purple">$25,000</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Insured</label>
                  <div class="bold fs-14 purple">Dummy</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Insured Amt.</label>
                  <div class="bold fs-14 purple">$25,000</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Arrival Date</label>
                  <div class="bold fs-14 purple">04/17/2022</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Days</label>
                  <div class="bold fs-14 purple">11</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Option</label>
                  <div class="bold fs-14 purple">Dummy</div>
              </div>
          </div>
          <div class="clear10"></div>
          <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                  <label class="regular fs-14 txt-lightblack2">Option</label>
                  <div class="bold fs-14 purple">Wait Periodc</div>
              </div>
          </div>
      </div>
      <div class="clear20"></div>
      <div class="whitebox1">
          <label class="bold fs-16 txt-red m-0">Previous Payments&nbsp;&nbsp;<u class="link cp" (click)="showPaymentHistoryPopup=!showPaymentHistoryPopup">View History</u></label>
          <div class="clear5"></div>
          <div class="border-bottom"></div>
          <div class="clear5"></div>
          <div class="row">
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Date</label>
                  <div class="bold fs-14 purple">04/15/2022</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Type</label>
                  <div class="bold fs-14 purple">Cheque</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                  <div class="bold fs-14 purple">$11</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                  <div class="bold fs-14 purple">$00</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Card Number</label>
                  <div class="bold fs-14 purple">04152022</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">EXp</label>
                  <div class="bold fs-14 purple">04/15/2022</div>
              </div>
          </div>
      </div>
      <div class="clear20"></div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
          <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepFourBack()">Go Back</button>
          <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickChangePolicyStepFourNext()">Finalize Payment</button>
        </div>
      </div>
      </div> -->
        <!-- New Payments Page Start -->
        <div *ngIf="showChangePolicyStepFour" class="p-3" >
          <div  *ngFor="let item of policyIDDetail;let i=index">
          <div class="clear10"></div>

            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Cancel</button>
                <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepFourBack()">Back</button>
                <button type="submit" class="ContinueandNextbtn1  mr-2 bold" [hidden]="Refund!=='No Charge' " (click)="changeFlagOnSave();onClickChangePolicyStepFourNext()">Save</button>
                <button type="submit" class="ContinueandNextbtn ml-1 bold" [disabled]="cardexpdateFlagButtonDisable" [hidden]="Refund=='No Charge' "(click)="getPaymentTokens()">{{FinalizeBtnName}}</button>
              </div>
            </div>
          

      <label class="bold fs-16 txt-black">PLAN AND PAYMENT DETAILS</label>
      <div class="clear10"></div>
      <div class="horizontal"></div>
      <div class="clear10"></div>
          <div class="whitebox1 outerbox">
              <label class="bold fs-16 txt-red ml-3 mt-1">Payment</label>
              <div class="clear5"></div>
              <div class="border-bottom"></div>
              <div class="clear5"></div>
              <div class="row background Boxsize">
                  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 ml-10 mt-1">
                      <label class="regular fs-14 txt-lightblack2">{{Refund}} <span style="text-align:center">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;=</span></label>
                      <!-- <label class="regular fs-14 txt-lightblack2" *ngIf="Refund==true">Refund Amount <span style="text-align:center">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;=</span></label> -->
                      <div class="bold fs-14 green">{{Amounttotal}}</div>
                  </div>
                  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 mt-1">
                      <label class="regular fs-14 txt-lightblack2">Premium <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+</span></label>
                      <div class="bold fs-14 purple">{{PaymentPremium}}</div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12 mt-1">
                      <label class="regular fs-14 txt-lightblack2">Tax <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+</span></label>
                      <div class="bold fs-14 purple">{{Tax}}</div>
                  </div>
                  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 mt-1">
                      <label class="regular fs-14 txt-lightblack2">Total Admin Fee <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+</span></label>
                      <div class="bold fs-14 purple">{{adminFee}}</div>
                  </div>
                  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 mt-1">
                      <label class="regular fs-14 txt-lightblack2">Total Billing Fee <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span></label>
                      <div class="bold fs-14 purple">{{TotalBillingFee}}</div>
                  </div>
                  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 mt-1">
                    <label class="regular fs-14 txt-lightblack2">Previous Payments</label>
                    <div class="bold fs-14 purple">{{PreviousPayments}}</div>
                </div>
              </div>
          </div>
          <div class="clear20"></div>
          <div class="whitebox1 Planbox" >
              <label class="bold fs-16 txt-red m-0 ml-3">Plan : TAI- Premier - </label>
              <label class="bold fs-16 txt-red m-0">&nbsp;&nbsp;{{planName}}</label>
              <div class="clear5"></div>
              <div class="border-bottom"></div>
              <div class="clear5"></div>
              <div class="insuredBox PlanInnerbox" *ngFor="let data of insuredinfoArray; let j=index"  >
                <div class="row">
                  <label class="regular fs-14 txt-lightblack2 mb-0">Insured {{j+1}}: 
                      <span class="bold fs-14 purple">&nbsp;{{data.firstName}} {{data.lastName}}(Age:&nbsp;{{data.age}}, DOB:&nbsp;{{data.dateOfBirth | date:'ddMMMyyyy'}})</span>
                      <span class="regular fs-14 txt-lightblack2">, Days:&nbsp;</span><span class="bold fs-14 purple">{{daysToshow}}  ({{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}})</span>
                      <!-- <span class="regular fs-14 txt-lightblack2">, Trip Cost: </span><span class="bold fs-14 purple">{{data.tripCost}}</span> -->
                      <span class="regular fs-14 txt-lightblack2">, Premium:&nbsp;</span><span class="bold fs-14 purple">{{data.insurancePremium}}</span>
                      <span class="regular fs-14 txt-lightblack2">, Trip Cost:&nbsp;</span><span class="bold fs-14 purple">{{data.tripCost}}</span>
                  </label>
                </div>
                <div class="clear5"></div>
                <div class="row">
                  <span class="regular fs-14 txt-lightblack2">Arrival Date:&nbsp;</span><span class="bold fs-14 purple">({{data.arrivalDateInCanada | date:'ddMMMyyyy'}})</span>
                  <!-- <span class="regular fs-14 txt-lightblack2">, Deductible Option:&nbsp;</span><span class="bold fs-14 purple">{{data.policy.deductableOption}}</span>
                  <span class="regular fs-14 txt-lightblack2">, Deductible Option Premium:&nbsp;</span><span class="bold fs-14 purple">{{data.deductableOptionPremium}}</span> -->
                </div>
                <div class="clear5"></div>
                <div class="row">
                  <span class="regular fs-14 txt-lightblack2">Wait Period:&nbsp;</span><span class="bold fs-14 purple">{{data.waitPeroid}}</span>
                  <!-- <span class="regular fs-14 txt-lightblack2">, Wait Period Premium:&nbsp;</span><span class="bold fs-14 purple">{{data.waitPeriodPremium}}</span> -->
                </div>
              </div>
          </div>
            <div class="clear20"></div>
        <div class="payMentBox paymentoutbox col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
          <div class=" p-2">
              <!-- <img class="mr-2" src="./assets/images/quoteDetails.svg">-->
            <label class="txt-red bold fs-16">Enter Payment &nbsp;&nbsp;</label> <span class="regular fs-14 txt-lightblack2">(Note: Lines with no amount will be ignored)</span> 
          </div>
          <div class="clear5"></div>
          <div class="border-bottom"></div>
          <div class="clear5"></div>
         
          <div class="clear5"></div>
          <!-- <label class="bold fs-14 txt-red">Payment: 1</label> -->
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
              <label class="regular fs-14 txt-black">Total Amount</label>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <label class="regular fs-14 txt-black">Payment Type</label>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <label class="regular fs-14 txt-black">Card Number</label>
            </div>
            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
              <label class="regular fs-14 txt-black">CVV</label>
            </div> -->
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <label class="regular fs-14 txt-black">Expiry (mm/yy)</label>
            </div>
          </div>
          <div class="clear5"></div>
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
              <div class="mb-3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount" >
            </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType1" (ngModelChange)="changePaymentType(cardType1)">
                <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                <!-- <ng-option  value="{{ssl_card_number}}">{{ssl_card_number}}</ng-option> -->
                  <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount'" value="VISA">Visa</ng-option>
                  <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount'" value="MasterCard">Master Card</ng-option>
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="AmericanExpress">American Express</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showCardNo1">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber1" maxlength="16">
              </div>
            </div>
            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
              <div class="mb-3" *ngIf="showCVV1">
                <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv1"  maxlength="3">
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showexp1">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate1" maxlength="5" (input)="CCExpdate1()">
                <p class="dateSubtxt1 redstar" *ngIf="cardexpdate1Flag">Invalid Exp Date</p>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
              <div class="mb-3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount2" >
            </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType2" (ngModelChange)="changePaymentType2(cardType2)">
                <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                <!-- <ng-option  value="{{ssl_card_number}}">{{ssl_card_number}}</ng-option> -->
                  <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="VISA">Visa</ng-option>
                  <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="MasterCard">Master Card</ng-option>
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="AmericanExpress">American Express</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showCardNo2">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber2" maxlength="16">
              </div>
            </div>
            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
              <div class="mb-3" *ngIf="showCVV2">
                <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv2"  maxlength="3">
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showexp2">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate2" maxlength="5" (input)="CCExpdate2()">
                <p class="dateSubtxt1 redstar" *ngIf="cardexpdate2Flag">Invalid Exp Date</p>
              </div>
            </div>
          </div>
         
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
              <div class="mb-3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount3" >
            </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType3" (ngModelChange)="changePaymentType3(cardType3)">
                <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                <!-- <ng-option  value="{{ssl_card_number}}">{{ssl_card_number}}</ng-option> -->
                  <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="VISA">Visa</ng-option>
                  <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="MasterCard">Master Card</ng-option>
                  <ng-option *ngIf="Refund!=='Refund Amount' " value="AmericanExpress">American Express</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showCardNo3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber3" maxlength="16">
              </div>
            </div>
            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
              <div class="mb-3" *ngIf="showCVV3">
                <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv3"  maxlength="3">
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showexp3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate3" maxlength="5" (input)="CCExpdate3()">
                <p class="dateSubtxt1 redstar" *ngIf="cardexpdate3Flag">Invalid Exp Date</p>
              </div>
            </div>
          </div>
         
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
              <div class="mb-3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount4" >
            </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType4" (ngModelChange)="changePaymentType4(cardType4)">
                <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                <!-- <ng-option  value="{{ssl_card_number}}">{{ssl_card_number}}</ng-option> -->
                  <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount' "  value="VISA">Visa</ng-option>
                  <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                  <ng-option *ngIf="Refund!=='Refund Amount' "  value="MasterCard">Master Card</ng-option>
                  <ng-option *ngIf="Refund!=='Refund Amount' "  value="AmericanExpress">American Express</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showCardNo4">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber4" maxlength="16">
              </div>
            </div>
            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
              <div class="mb-3" *ngIf="showCVV4">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv4"  maxlength="3">
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showexp4">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate4" maxlength="5" (input)="CCExpdate4()">
                <p class="dateSubtxt1 redstar" *ngIf="cardexpdate4Flag">Invalid Exp Date</p>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12" >
              <div class="mb-3">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Total amount" [(ngModel)]="Amount5" >
            </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 mb-3" placeholder="Select"   [(ngModel)]="cardType5" (ngModelChange)="changePaymentType5(cardType5)">
                <ng-option *ngFor="let item of policypaymentdetailsArray;let i=index" [value]="item">{{item.transactionPaymentDetails[0].sslCardNumber}}</ng-option>
                <!-- <ng-option  value="{{ssl_card_number}}">{{ssl_card_number}}</ng-option> -->
                  <!-- <ng-option value="Cheque">Cheque</ng-option> -->
                  <ng-option  value="VISA">Visa</ng-option>
                  <!-- <ng-option value="CREDITCARD">CREDITCARD</ng-option> -->
                  <ng-option  value="MasterCard">Master Card</ng-option>
                  <ng-option  value="AmericanExpress">American Express</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showCardNo5">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Card number" [(ngModel)]="CardNumber5" maxlength="16">
              </div>
            </div>
            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-1 col-12">
              <div class="mb-3" *ngIf="showCVV5">
                <input  type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvv5"  maxlength="3">
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
              <div class="mb-3" *ngIf="showexp5">
                <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="mm/yy" [(ngModel)]="cardexpdate5" maxlength="5" (input)="CCExpdate5()">
                <p class="dateSubtxt1 redstar" *ngIf="cardexpdate5Flag">Invalid Exp Date</p>
              </div>
            </div>
          </div>





          
          
          <!-- <div class="clear20"></div> -->
          <!-- <button type="button" class="fs-14 bold splitPaymentbtn">Split Payment</button> -->
      </div>
      <!-- <div class="clear10"></div>
      <label class="bold fs-16 txt-black">PLAN AND PAYMENT DETAILS</label>
      <div class="clear10"></div> -->
      <!-- <div class="whitebox1">
        <label class="bold fs-16 txt-red m-0">Payments</label>
        <div class="clear5"></div>
        <div class="border-bottom"></div>
        <div class="clear5"></div>
        <div class="row">
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Amount</label>
                <div class="bold fs-14 green">$403.02</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Premium</label>
                <div class="bold fs-14 purple">$373.75</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Tax</label>
                <div class="bold fs-14 purple">$11</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                <div class="bold fs-14 purple">$20</div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                <label class="regular fs-14 txt-lightblack2">Total Billing Fee</label>
                <div class="bold fs-14 purple">$75</div>
            </div>
        </div>
    </div>
      <div class="clear20"></div> -->
      <!-- <div class="whitebox1">
          <label class="bold fs-16 txt-red m-0">Plan:</label>
          <label class="bold fs-16 txt-red m-0">&nbsp;&nbsp;Visitors To Canada Premier Plan</label>
          <div class="clear5"></div>
          <div class="border-bottom"></div>
          <div class="clear5"></div>
          <div class="row">
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Total</label>
                  <div class="bold fs-14 purple">$25,000</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Insured</label>
                  <div class="bold fs-14 purple">Dummy</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Insured Amt.</label>
                  <div class="bold fs-14 purple">$25,000</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Arrival Date</label>
                  <div class="bold fs-14 purple">04/17/2022</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Days</label>
                  <div class="bold fs-14 purple">11</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Option</label>
                  <div class="bold fs-14 purple">Dummy</div>
              </div>
          </div>
          <div class="clear10"></div>
          <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                  <label class="regular fs-14 txt-lightblack2">Option</label>
                  <div class="bold fs-14 purple">Wait Periodc</div>
              </div>
          </div>
      </div> -->
      <div class="clear20"></div>
      <div class="whitebox1 outerbox">
          <label class="bold fs-16 txt-red m-0 ml-3 mt-2">Previous Payments</label>
          <!-- <label class="bold fs-16 txt-red m-0 ml-3 mt-2">Previous Payments&nbsp;&nbsp;<u class="link cp" (click)="showPaymentHistoryPopup =!showPaymentHistoryPopup">View History</u></label> -->
          <div class="clear5"></div>
          <div class="border-bottom"></div>
          <div class="clear5"></div>
          <div class="row background Boxsize mt-2 p-2" *ngFor="let data of item.transactions;let i=index">
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 ml-3">
                  <label class="regular fs-14 txt-lightblack2">Date</label>
                  <div class="bold fs-14 purple">{{data.transactionPaymentDetails[0].sslTxnTime | date:'ddMMMyyyy'}}</div>
              </div>
              <!-- <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Type</label>
                  <div class="bold fs-14 purple">Cheque</div>
              </div> -->
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                  <div class="bold fs-14 purple">{{data.transactionPaymentDetails[0].sslAmount}}</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                  <div class="bold fs-14 purple">{{data.transactionPaymentDetails[0].adminFee}}</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">Card Number</label>
                  <div class="bold fs-14 purple">{{data.transactionPaymentDetails[0].sslCardNumber}}</div>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                  <label class="regular fs-14 txt-lightblack2">EXP</label>
                  <div class="bold fs-14 purple">{{data.transactionPaymentDetails[0].sslExpDate}}</div>
              </div>
          </div>
      </div>
      <div class="clear20"></div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
          <button type="submit" class="backbtn mr-2 bold" (click)="backToPolicyDetails()">Cancel</button>
          <button type="submit" class="backbtn mr-2 bold" (click)="onClickChangePolicyStepFourBack()">Back</button>
          <button type="submit" class=" ContinueandNextbtn1  mr-2 bold" [hidden]="Refund!=='No Charge' " (click)="changeFlagOnSave();onClickChangePolicyStepFourNext()">Save</button>
          <button type="submit" class="ContinueandNextbtn ml-1 bold" [disabled]="cardexpdateFlagButtonDisable" [hidden]="Refund=='No Charge' "(click)="getPaymentTokens()">{{FinalizeBtnName}}</button>
        </div>
      </div>
      </div>
      </div>
      <!-- Payment Histry Pop-up -->
      <div id="showPaymentHistoryPopup" class="modal" [style.display]="showPaymentHistoryPopup ? 'block' : 'none'">
        <!-- Modal content -->
        <div class="modal-dialog modal-lg">
            <div class="modal-content w-100">
              <div class="modal-header">
                <span class="fs-16 text46 semi-bold">Payment History</span>
                <h6 class="close text-right" (click)="showPaymentHistoryPopup=!showPaymentHistoryPopup">&times;</h6>
            </div>
                <div class="modal-body m-0">
                  <div class="tableheadFix">
                    <table id="tableheadFixMonthlyPay" class="w100">
                        <thead class="nowrap">
                            <tr>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>DATE</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Type</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>PAYMENT AMOUNT</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>ADMIN FEE</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>CARD NUMBER</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>EXP (MMYY)</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr>
                                <td>Dummy</td>
                                <td>Dummy</td>                      
                                <td>Dummy</td>                      
                                <td>Dummy</td>                      
                                <td>Dummy</td> 
                                <td>Dummy</td>                      
                            </tr>
                            <tr>
                              <td>Dummy</td>
                              <td>Dummy</td>                      
                              <td>Dummy</td>                      
                              <td>Dummy</td>                      
                              <td>Dummy</td> 
                              <td>Dummy</td>                      
                          </tr><tr>
                            <td>Dummy</td>
                            <td>Dummy</td>                      
                            <td>Dummy</td>                      
                            <td>Dummy</td>                      
                            <td>Dummy</td> 
                            <td>Dummy</td>                      
                        </tr><tr>
                          <td>Dummy</td>
                          <td>Dummy</td>                      
                          <td>Dummy</td>                      
                          <td>Dummy</td>                      
                          <td>Dummy</td> 
                          <td>Dummy</td>                      
                      </tr>
                        </tbody>
                    </table>
                </div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                            <button type="button" class="olnone fs-16 semi-bold dltclosebtn text46 mr-2" (click)="showPaymentHistoryPopup=!showPaymentHistoryPopup">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
<!-- Payments Page End -->
      <div *ngIf="showChangePolicyStepFive" class="p-3">
        <div class="clear10"></div>
        <span class="greentick"><img src="./assets/images/greentick.png" alt="" srcset=""></span><label class="bold fs-16 green ml-2">Policy Successfully Changed</label>
      <div class="clear20"></div>
      <label class="bold fs-16 txt-black">Request Fulfillment</label>
      <div class="clear20"></div>
      <div class="row">
       
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <label class="regular fs-16">Email</label>
          <input type="text"  class="form-control forminput col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" [(ngModel)]="email1" placeholder="example@gmail.com" (input)="onRemoveEmailError()">
          <p class="regular redstar" *ngIf="emailErrorFlag">Email is required.</p>
        </div>
      </div>
      <div class="clear20"></div>
      <label class="bold fs-16 txt-black">Previous Fulfillments</label>
      <div class="clear20"></div>
      <div class="tableheadFix">
        <table id="tableheadFixMonthlyPay" class="w50">
            <thead class="nowrap">
                <tr>
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>EMAIL ADDRESS</span>
                            <!-- <div class="d-flex flex-column ml-4">
                                <i class="fa fa-caret-up"></i>
                                <i class="fa fa-caret-down"></i>
                            </div> -->
                        </div>
                    </th>
                    <!-- <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>STATUS</span>
                            <div class="d-flex flex-column ml-4">
                                <i class="fa fa-caret-up"></i>
                                <i class="fa fa-caret-down"></i>
                            </div>
                        </div>
                    </th> -->
                    <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>REQUEST DATE</span>
                            <!-- <div class="d-flex flex-column ml-4">
                                <i class="fa fa-caret-up"></i>
                                <i class="fa fa-caret-down"></i>
                            </div> -->
                        </div>
                    </th>
                    <!-- <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>FIRST NAME</span>
                            <div class="d-flex flex-column ml-4">
                                <i class="fa fa-caret-up"></i>
                                <i class="fa fa-caret-down"></i>
                            </div>
                        </div>
                    </th> -->
                    <!-- <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>LAST NAME</span>
                            <div class="d-flex flex-column ml-4">
                                <i class="fa fa-caret-up"></i>
                                <i class="fa fa-caret-down"></i>
                            </div>
                        </div>
                    </th> -->
                    <!-- <th>
                        <div class="d-flex flex-row align-items-center">
                            <span>ADDRESS 1</span>
                            <div class="d-flex flex-column ml-4">
                                <i class="fa fa-caret-up"></i>
                                <i class="fa fa-caret-down"></i>
                            </div>
                        </div>
                    </th>
                    <th>
                      <div class="d-flex flex-row align-items-center">
                          <span>City</span>
                          <div class="d-flex flex-column ml-4">
                              <i class="fa fa-caret-up"></i>
                              <i class="fa fa-caret-down"></i>
                          </div>
                      </div>
                  </th> -->
                </tr>
            </thead>
            <tbody class="">
                <tr *ngFor="let data of fulfillmentArray; let j=index">
                    
                    <td>{{data.email}}</td>              
                    <td>{{data.createdAt | date:'ddMMMyyyy'}}</td>                         
                </tr>
            </tbody>
        </table>
    </div>
    <div class="clear20"></div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
        <button type="submit" class="backbtn mr-2 bold" (click)="returnHome()">Return Home</button>
        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onSendEmail()">Request fulfillment</button>
        <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onSendEmail();onClickChangePolicyStepFiveNext()">Request fulfillment</button> -->
      </div>
    </div>
      </div>
    </div>
  </div>
      </div>
      